import { MissingTranslationReportList } from '../../../components/Report';

export function MissingTranslationsReports() {
  return <MissingTranslationReportList />;
}
